import React from 'react'
import { IonPage, IonContent, IonText, useIonViewDidEnter } from '@ionic/react'
import Header from '../../components/Header'
import {
    AddIcon,
    ArrowRightIcon,
    DeleteIcon,
    DeleteDisableIcon,
} from '../../conf/images'
import './index.css'
import { useHistory } from 'react-router'
import { BotPushServiceDetailPage } from '../../conf/routePath'
import {
    delPushServiceSetting,
    getPushServiceSettings,
} from '../../service/api/bot'

export type ContactsType = {
    contacts_type: string
    describe: string
    head_url: string
    name: string
    uid: string
}

export type BotPushServiceSetting = {
    name: string
    friend_reply_object_type: string
    friend_reply_list: ContactsType[]
    group_reply_object_type: string
    group_reply_list: ContactsType[]
    reply_frequency: string
    days_of_week: string[]
    day_of_once: string
    reply_time: string
    msg_list: {
        msg_body: {
            msg_type: string
            content: string
        }
    }[]
    id: string
}

const BotPushService: React.FC<{}> = () => {
    const history = useHistory()
    const [list, setList] = React.useState<BotPushServiceSetting[]>([])
    const [listMode, setListMode] = React.useState<boolean>(true)

    const handleDel = (item: BotPushServiceSetting, index: number) => {
        if (listMode) {
            history.push(BotPushServiceDetailPage, { item: item })
        } else {
            const tmp = [...list]
            tmp.splice(index, 1)
            setList(tmp)
            delPushServiceSetting(item.id)
        }
    }

    useIonViewDidEnter(() => {
        getPushServiceSettings().then((res) => setList(res.data))
    })

    return (
        <IonPage>
            <IonContent className='mybot-content'>
                <Header title='消息推送' backable>
                    {!!list?.length && (
                        <img
                            className='botPushServiceDelIcon'
                            src={DeleteDisableIcon}
                            alt='store'
                            onClick={() => setListMode((b) => !b)}
                        />
                    )}
                    <img
                        className='botPushServiceAddIcon'
                        src={AddIcon}
                        alt='store'
                        onClick={() => {
                            history.push(BotPushServiceDetailPage)
                        }}
                    />
                </Header>
                {Array.isArray(list) && list.length > 0 ? (
                    list.map((item, index) => (
                        <div className='botPushServiceItem' key={item.id}>
                            <IonText>{item.name}</IonText>
                            <img
                                src={listMode ? ArrowRightIcon : DeleteIcon}
                                alt='icon'
                                onClick={() => handleDel(item, index)}
                            />
                        </div>
                    ))
                ) : (
                    <div className='botPushServiceEmpty'>
                        <IonText>还没有任何推送配置，点击右上角添加吧!</IonText>
                    </div>
                )}
            </IonContent>
        </IonPage>
    )
}

export default BotPushService
